<script lang="ts" setup>
import {SynchroDirection} from "@/domain/type/synchro.type.ts";
import {computed} from "vue";
import {RequestEntity, type SynchroRequestField} from "@/domain/type/synchro.api.type.ts";
import FusionTextArea from "@/components/Fusion/FusionTextArea.vue";

const props = defineProps<{
  request: SynchroRequestField,
  entity: RequestEntity
}>()

const model = defineModel()

const isSelectable = computed(function () {
  return 0 !== props.request.valueSrc1.length && !props.request.readOnlySrc2 && !props.request.isSynchronized
})
const isSelected = computed(function () {
  return SynchroDirection.SRC1_TO_SRC2 === model.value
})
const labelTextColor = computed(function () {
  if (undefined !== model.value || props.request.isDisallowed) {
    return 'text-white'
  }
  return 'text-grey-darken-2'
})

function getLabel(): string {
  let text = props.request.label.split(' <=> ')[0]

  if (props.request.isOptionnel) {
    text += ' (optionnel)'
  }

  return text
}

function getValue(): string {
  return props.request.displayValueSrc1 ?? props.request.valueSrc1
}

function onSubmit() {
  if (isSelected.value) {
    model.value = undefined
  } else {
    model.value = SynchroDirection.SRC1_TO_SRC2
  }
}
</script>

<template>

  <div class="d-flex align-center h-100">
    <div class="d-flex flex-column flex-grow-1 overflow-hidden h-100">
      <label
        :class="labelTextColor"
        class="pb-0 text-small text-no-wrap"
      >
        {{ getLabel() }}
      </label>
      <fusion-text-area class="flex-grow-1" :label="getLabel()" :request="request" :synchro-type="entity.requestType" :value="getValue()"/>
    </div>
    <div class="d-flex flex-column">
      <label
        class="pb-0 text-subtitle-2"
        style="min-width: 1px"
      >
        &nbsp;
      </label>
      <v-tooltip v-if="request.readOnlySrc2 && request.readOnlySrc2Info && !request.isSynchronized" :text="request.readOnlySrc2Info" width="200">
        <template v-slot:activator="{ props }">
          <v-btn
            class="mx-2 src2Btn"
            color="#0066fb"
            density="compact"
            icon="mdi-lock"
            size="sm"
            v-bind="props"
            variant="text"
          />
        </template>
      </v-tooltip>
      <v-btn
        v-else-if="!request.isSynchronized"
        :class="{'cursor-not-allowed':!isSelectable}"
        :color="isSelected || request.isDisallowed || entity.isDisallowed() ? 'grey':'green'"
        :disabled="!isSelectable || request.readOnlySrc2 || request.isDisallowed || entity.isDisallowed()"
        :icon="isSelected ? 'mdi-trash-can-outline':'mdi-arrow-right'"
        class="mx-2"
        density="compact"
        size="sm"
        @click="onSubmit()"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
